import React from "react";
import { Box, ScrollArea, Text, Group } from "@mantine/core";
import type { Suggestion } from "@/hooks/useFilterSearch";
import capitalize from "lodash/capitalize";
import styles from "./styles.module.scss";

interface SearchResultsProps {
  opened: boolean;
  suggestions: Suggestion[];
  highlighted: number | null;
  scrollRef: React.RefObject<HTMLDivElement | null>;
  onHighlight: (index: number) => void;
  onSelect: (suggestion: Suggestion, fromDropdown: boolean) => void;
}

export const SearchResults = React.memo<SearchResultsProps>(
  ({ opened, suggestions, highlighted, scrollRef, onHighlight, onSelect }) => {
    if (!opened) return null;

    return (
      <Box component="div" p="sm" data-testid="search-results">
        <ScrollArea.Autosize mah={300} viewportRef={scrollRef}>
          <Box component="ul" m={0} style={{ listStyle: "none" }}>
            {suggestions.length === 0 && (
              <Box px="sm" py="xs" data-testid="no-matches">
                <Text size="sm" c="dimmed">
                  No matches
                </Text>
              </Box>
            )}
            {suggestions.map((s, i) => (
              <Box
                key={`${s.key}-${s.option.id}`}
                component="li"
                data-testid={`suggestion-${i}`}
                data-highlighted={highlighted === i}
                px="sm"
                py={10}
                className={`${styles.suggestionItem} ${highlighted === i ? styles.highlighted : ""}`}
                onMouseEnter={() => onHighlight(i)}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onSelect(s, true);
                }}
              >
                <Group gap="xs" align="center">
                  <Box px={3} className={styles.suggestionTag}>
                    {s.key === "preset" ? "Saved" : capitalize(s.key)}
                  </Box>
                  <Text size="sm" fw={500}>
                    {s.option.label}
                  </Text>
                </Group>
              </Box>
            ))}
          </Box>
        </ScrollArea.Autosize>
      </Box>
    );
  }
);

SearchResults.displayName = "SearchResults";
